import { Router } from './Router';
import { ConfigProvider } from './context/Config.context';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC, useState } from 'react';

Sentry.init({
  dsn: 'https://86a2bb994b16e81705207f556356de28@o71554.ingest.us.sentry.io/4509133355548672',
  // ...
});

const App: FC = () => {
  const [queryClient] = useState(() => new QueryClient({}));

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <Router />
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default App;
